import { Children, FC } from 'react';
import styled from 'styled-components';
import { PlaceholderTabs } from '../ContentPlaceholder/PlaceholderTabs';
import { Tab } from './Tab';

const TabBarElement = styled.div<Pick<IProps, 'borderVariation'>>`
  display: flex;
  position: relative;
  border-bottom: ${({ borderVariation, theme }) =>
    borderVariation === 'clean' ? 'none' : `1px solid ${theme.vars.newColor.lightGS1}`};
  z-index: 5;
  align-items: center;
`;

const TabListElement = styled.div<Pick<IProps, 'topPadding'>>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  ${({ topPadding }) => (topPadding || topPadding === 0 ? `padding: ${topPadding}rem 0 0 0;` : 'padding: 2rem 0 0 0;')}
  && > * {
    flex-wrap: nowrap;
    flex-shrink: 0;
  }
`;

const RightElement = styled.div`
  padding-right: 20px;
  margin-left: 20px;
`;

export type TabBarBorderVariation = 'normal' | 'primary' | 'clean';

export interface IProps {
  borderVariation?: TabBarBorderVariation;
  onClick?: (tab: string) => void;
  sliderPos?: number;
  sliderWidth?: number;
  /** If true, displays content placeholder.  Defaults to false. */
  loading?: boolean;
  /** top padding value in rem. Defaults to 2 */
  topPadding?: number;
}

export const TabBar: FC<IProps> = props => {
  function renderTabs() {
    const tabs = [];
    const otherComponents = [];
    Children.forEach(props.children, (child: any) => {
      if (child && child.type === Tab) {
        tabs.push(child);
      } else {
        otherComponents.push(child);
      }
    });
    return [
      <TabListElement key={1} topPadding={props.topPadding}>
        {tabs}
      </TabListElement>,
      <RightElement key={2}>{otherComponents}</RightElement>,
    ];
  }

  if (props.loading) {
    return (
      <TabBarElement borderVariation={props.borderVariation} data-testid="TabBarElement">
        <PlaceholderTabs numTabs={Children.count(props.children)} height="64px" />
      </TabBarElement>
    );
  }

  return (
    <TabBarElement borderVariation={props.borderVariation} data-testid="TabBarElement">
      {renderTabs()}
    </TabBarElement>
  );
};
